/**
 * Internal dependencies
 */
import { useSelector } from '@/store';

const useCurrentUser = () => useSelector(({ auth }) => auth.user);

export default useCurrentUser;
